import { useSelector } from 'react-redux'

import { TRoles } from './const'

/*
 * Nur-Lese-Zugang „Alumni" (Anforderung #213, JA Alumni Austria).
 *
 * Bundesweit und nur lesend: Alumni sehen, was in der Datenbank neu ist — mit
 * Namen, aber ohne E-Mail-Adressen, Telefonnummern, Geburtsdaten und Adressen
 * von Schüler:innen und Lehrkräften, ohne Dokumente und Exporte, ohne
 * Anforderungen, Einstellungen, Administration und Kommunikation.
 *
 * **Geschützt wird im Backend** (`services/alumni`: Positivliste der Routen,
 * Feldfilter an jeder Antwort). Diese Datei sorgt nur dafür, dass die
 * Oberfläche keinen Knopf zeigt, den der Server verweigern würde, und keine
 * Seite anbietet, deren Abfragen mit 403 enden.
 */
export const isAlumni = role => role === TRoles.ALUMNI

/*
 * Seiten der Verwaltung, die Alumni öffnen dürfen. Jede Seite unter
 * `pages/` fragt selbst nach der Rolle; die hier genannten lassen Alumni ein,
 * alle anderen schicken sie auf das Dashboard zurück.
 */
export const ALUMNI_PAGES = [
	'dashboard',
	'companies',
	'companyReview',
	'conceptReport',
	'schools',
	'users',
	'reports',
	'reportReview',
	'invoices',
	'supporters',
	'supportRequests',
	'news',
	'handbook',
	'profile'
]

/**
 * Darf diese Rolle die Seite der Verwaltung sehen? Landes- und Bundesadmins
 * wie bisher, Alumni nur die Seiten aus `ALUMNI_PAGES`.
 */
export const mayOpenAdminPage = (role, page) =>
	role === TRoles.ADMIN || role === TRoles.FEDERAL_ADMIN || (isAlumni(role) && ALUMNI_PAGES.includes(page))

/**
 * In einer Ansicht: Ist die angemeldete Person nur lesend unterwegs? Dann
 * fehlen Anlegen, Bearbeiten, Löschen, Export und Herunterladen.
 */
export const useIsReadOnly = () => useSelector(state => isAlumni(state.user?.role))

/*
 * Statt einer Kontaktangabe, die Alumni nicht sehen (der Server schickt sie
 * gar nicht erst): ein Strich, kein leeres Feld — ein leeres Feld sähe aus wie
 * „nicht eingetragen".
 */
export const HIDDEN_VALUE = '–'
